const actions = {
  WIFI_ACTIVATION: "WIFI_ACTIVATION",
  WIFI_ACTIVATION_SUCCESS: "WIFI_ACTIVATION_SUCCESS",
  WIFI_ACTIVATION_FAILED: "WIFI_ACTIVATION_FAILED",

  CANCEL_WIFI_ACTIVATION: "CANCEL_WIFI_ACTIVATION",
  CANCEL_WIFI_ACTIVATION_SUCCESS: "CANCEL_WIFI_ACTIVATION_SUCCESS",
  CANCEL_WIFI_ACTIVATION_FAILED: "CANCEL_WIFI_ACTIVATION_FAILED",


  RESET_MESSAGE: "RESET_MESSAGE",

  createWiFiActivation: (data) => ({
    type: actions.WIFI_ACTIVATION,
    payload: { data },
  }),
  createWiFiActivationSuccess: (message) => ({
    type: actions.WIFI_ACTIVATION_SUCCESS,
    payload: { message }
  }),
  createWiFiActivationFailed: (error) => ({
    type: actions.WIFI_ACTIVATION_FAILED,
    payload: { error },
  }),

  cancelWiFiActivation: (data) => ({
    type: actions.CANCEL_WIFI_ACTIVATION,
    payload: { data },
  }),
  cancelWiFiActivationSuccess: (message) => ({
    type: actions.CANCEL_WIFI_ACTIVATION_SUCCESS,
    payload: { message }
  }),
  cancelWiFiActivationFailed: (error) => ({
    type: actions.CANCEL_WIFI_ACTIVATION_FAILED,
    payload: { error },
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),


}

export default actions;